export default "__VITE_ASSET__471c1707__"